<template>
    <div>
        <StepHeader
            v-if="isImage"
            :subtitle="subtitle"
            :description="description"
        />
        <StepQuality
            v-if="isImage"
            :subtitle="qualityForm[0].title"
            :forms="qualityForm"
            :selectedValue="{
                'media': selectedValue['media'],
                'color': selectedValue['color'],
                'quality': selectedValue['quality'],
                'preset': selectedValue['preset']
            }"
            :selectedQuality="selectedValue['quality']"
            :defaultQuality="defaultQuality"
            :defaultsPresetValues="defaultsPresetValues"
            @set-properties="setAdvancedPresetProperties"
        />
        <StepOptions
            :subtitle="optionsForm.title"
            :forms="optionsForm"
            :selectedOption="selectedValue['mention']"
            :hasSubHeader="isImage"
            @update-disclaimer="updateDisclaimer"
        />
    </div>
</template>

<script>
    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import StepQuality from '@/components/myHabiteoStudio/steps/StepQuality';
    import StepOptions from '@/components/myHabiteoStudio/steps/StepOptions';
    export default {
        name: 'StepPersonnalization',
        components: {
            StepHeader,
            StepQuality,
            StepOptions
        },
        props: {
            subtitle: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            filteredForms: {
                type: Array,
                required: true
            },
            selectedValue: {
                type: Object,
                required: false
            },
            defaultQuality: {
                type: String,
                required: false
            },
            defaultsPresetValues: {
                type: String,
                required: false
            }
        },
        computed: {
            qualityForm() {
                return this.$props.filteredForms.filter(el => el.id === 'quality' || el.id === 'preset');
            },
            optionsForm() {
                return this.$props.filteredForms.find(el => el.id === 'mention');
            },
            isImage() {
                return this.$props.selectedValue['media'] === 1;
            }
        },
        methods: {
            setAdvancedPresetProperties(properties) {
                this.$emit('set-properties', properties);
            },
            updateDisclaimer(disclaimer) {
                this.$emit('update-disclaimer', disclaimer);
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepPersonnalization.vue